import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiShoppingBag } from "react-icons/fi";
import WishlistItemCard from "../components/Wishlist/WishlistItemCard";
import WishlistModal from "../components/Wishlist/WishlistModal";

const WishlistPage = () => {
//   const { wishlist, toggleWishlist } = useWishlist();
const navigate= useNavigate();
const { wishlist, removeFromWishlist } = useWishlist();
  const { addToCart } = useCart();

  const [modalData, setModalData] = useState(null);
  const [toast, setToast] = useState(null);

  return (
    <div className="w-full px-3 sm:px-4 md:px-6 lg:px-8 py-20">

      {/* HEADER */}
      {/* <div className="flex items-center gap-4 mb-10">
        <h1 className="text-3xl md:text-4xl font-bold tracking-widest uppercase">
          My Wishlist
        </h1>
        <span className="text-gray-600 text-lg">
          {wishlist.length} {wishlist.length === 1 ? "Item" : "Items"}
        </span>
      </div> */}

       {wishlist.length === 0 ? (
        <div className="flex flex-col items-center justify-center
                        min-h-[60vh] text-center px-4">

          {/* Icon Circle */}
          <div className="bg-gray-100 p-8 rounded-full mb-6">
           <FiShoppingBag className="text-6xl text-gray-400 mb-6" />
          </div>

          {/* Heading */}
          <h2 className="text-2xl md:text-3xl font-semibold mb-3">
            Your Wishlist is Empty
          </h2>

          {/* Description */}
          <p className="text-gray-500 text-sm md:text-base 
                        max-w-md mb-6">
            Save items you love to your wishlist.
            Review them anytime and easily move them to your bag.
          </p>

          {/* Button */}
          <button
            onClick={() => navigate("/products")}
            className="bg-black text-white px-10 py-3 rounded-lg
                       hover:scale-105 hover:bg-gray-800
                       transition-all duration-300 shadow-md"
          >
            Start Shopping
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
          {wishlist.map((item) => (
            <WishlistItemCard
              key={item._id}
              item={item}
              onAdd={() => setModalData({ type: "add", product: item })}
              onRemove={() => setModalData({ type: "remove", product: item })}
            />
          ))}
        </div>
      )}

      <WishlistModal
        modalData={modalData}
        onClose={() => setModalData(null)}
        onAddToCart={(product, size) => {
          addToCart({ ...product, size });
         
          setToast({ type: "success", product });
           // Auto-hide after 3 seconds
    setTimeout(() => setToast(null), 2000);
        }}
        onRemove={(product) => {
          removeFromWishlist(product);
          setToast({ type: "remove", product });
            // Auto-hide after 3 seconds
    setTimeout(() => setToast(null), 2000);
        }}
      />

      {/* TOAST */}
      {toast && (
        <div className="fixed top-20 right-6 bg-white shadow-xl border 
                        rounded-xl p-4 flex items-center gap-4 z-50 transition-opacity duration-500">
          <img
            // src={toast.product.image || toast.product.images?.[0]}
             src={toast.product.image}
            alt={toast.product.name}
            className="w-14 h-14 object-cover rounded-md"
          />
          <div>
            <p className="font-semibold text-sm">
              {toast.product.name}
            </p>
            <p className={`text-sm ${
              toast.type === "success"
                ? "text-green-600"
                : "text-red-500"
            }`}>
              {toast.type === "success"
                ? "Item added to cart"
                : "Item removed from wishlist"}
            </p>
          </div>
        </div>
      )}
      

    </div>
  );
};

export default WishlistPage;